import React from 'react';
import type { Nullable } from 'corgi-types';
import type { ReclamationReasonValue } from 'graphql-ts-types';

import { Flex } from 'common/components/Flex';
import { HeadlineH8 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import EditButton from '../EditButton';

export interface EditReasonButtonProps {
  reason: Nullable<ReclamationReasonValue>;
  isDisabled: boolean;
  onClick: (itemId: string) => void;
}

const EditReasonButton = ({ reason, isDisabled, onClick }: EditReasonButtonProps) => {
  const { r, t } = useLocalization();

  return (
    <Flex justifyContent="space-between" alignItems="flex-start">
      <HeadlineH8 as="h2" data-testid="reason">
        {reason ? reason.title : t('h24_click_here_to_provide_reason')}
      </HeadlineH8>
      <EditButton
        dataTestId="edit-reason-button"
        ariaLabel={
          reason
            ? `${r.t('h24_edit_reason', {
                reason: reason.title,
              })}`
            : `${t('h24_click_here_to_provide_reason')}`
        }
        isDisabled={isDisabled}
        onClick={onClick}
      />
    </Flex>
  );
};

export default EditReasonButton;
